import { createContext, useContext, useEffect, useState } from 'react';
import { getAllQueryParamsFromQueryString } from 'utils/urls';
import api from 'api';
import { useFeasibility } from 'hooks/useFeasibility';

const trackingPageContext = createContext();
trackingPageContext.displayName = 'trackingPageContext';
export function ProvideTrackingPage({ queryString, children }) {
  const trackingPage = useTrackingPageData(queryString);
  return (
    <trackingPageContext.Provider value={trackingPage}>
      {children}
    </trackingPageContext.Provider>
  );
}

export function useTrackingPage() {
  return useContext(trackingPageContext);
}

export function useTrackingPageData(queryString) {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const { setIsCoreNonCoreEnabled } = useFeasibility();

  const getData = async (qs) => {
    if (!qs) return;
    try {
      setLoading(true);
      setError(false);

      const { so: soId, lt } = getAllQueryParamsFromQueryString(qs) || {};

      if (!soId || !lt) {
        return console.error('[Missing parameter in query string]');
      }

      const { data: resultData } = await api.getTrackingData({
        shipperOrderId: soId,
        liveTrackingId: lt,
      });
      const trackingData = addExtraParamsInTrackingData({
        data: resultData,
        soId,
      });

      setIsCoreNonCoreEnabled(!!trackingData?.core_non_core_enabled);
      setData(trackingData);
    } catch (e) {
      console.error('[Error trying to request live tracking data]', e);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(
    () => {
      getData(queryString);
    },
    // eslint-disable-next-line
    [queryString]
  );

  return { data, loading, error };
}

function addExtraParamsInTrackingData({ data, soId }) {
  return {
    ...data,
    id: soId,
    loads: getLoads(data),
    drivers: getDriverPosition(data),
  };
}

function getLoads(data) {
  return data?.stops?.reduce((current, stop) => {
    return [...current, ...stop?.load_pickup];
  }, []);
}

function getDriverPosition(data) {
  const { drivers } = data;

  if (!drivers[0]) return drivers;

  drivers[0].last_position = data.last_position;
  drivers[0].user_id = drivers[0].id;

  return drivers;
}
